import template from './profiles-filter.html';
import profilesFilterController from './profiles-filter.controller';
import './profiles-filter.styl';

let profilesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: profilesFilterController,
  controllerAs: 'vm'
};

export default profilesFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/profiles-filter/profiles-filter.component.js
 **/